export const throwOnMissingConversationOrErrors = (data, mutationName) => {
  const payload = data?.[mutationName]
  const errors = payload?.errors || []

  if (payload?.conversation && errors.length === 0) return data

  const error = new Error(
    errors[0]?.message || `Unable to complete ${mutationName}`
  )
  error.errors = errors
  throw error
}
